'use client'
import React, { useEffect, useState } from 'react'
import Link from 'next/link'

// Icons
import { Icons } from '@/components/shared/icons'

// Components
import { Modal } from '@/components/ui/modal'
import { buttonVariants } from '@/components/ui/button'

// Config
import { siteConfig } from '@/config/site'
import { cn } from '@/lib/utils'

export function ScrollCTA() {
  const [showModal, setShowModal] = useState(false)
  const [isShown, setIsShown] = useState(false)

  useEffect(() => {
    if (isShown) return
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight
      const pageHeight = document.body.scrollHeight

      if (scrollPosition >= pageHeight * 0.5) {
        // Trigger at 50% scroll
        setShowModal(true)
        setIsShown(true)
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [isShown])

  return (
    <Modal
      showModal={showModal}
      setShowModal={setShowModal}
      title="Supercharge Your Stream with AI!"
      description="Let Algochat.io handle engagement while you focus on creating."
      className="max-h-[60svh] p-6 lg:min-w-[560px] "
    >
      <div>
        <div className="flex items-center">
          <Icons.logo className="size-8" />
          <span className="ml-2 inline-block font-satoshi text-xl font-bold">
            {siteConfig.name}
          </span>
        </div>
        <div className="prose mt-6 dark:prose-invert">
          <h2 className="mb-3 font-satoshi text-lg font-extrabold tracking-tight lg:text-xl">
            Boost Your Stream Engagement with AI-Powered Bots
          </h2>
          <p className="">
            Turn passive viewers into active participants with Algochat.io.
          </p>
        </div>
        <div className="mt-6 flex justify-center">
          <Link href="/" className={cn(buttonVariants({ variant: 'default' }))}>
            Try Algochat.io
          </Link>
        </div>
      </div>
    </Modal>
  )
}
